import { render, staticRenderFns } from "./AudienceGrowthSettings.vue?vue&type=template&id=48c7ad50&scoped=true"
import script from "./AudienceGrowthSettings.vue?vue&type=script&lang=js"
export * from "./AudienceGrowthSettings.vue?vue&type=script&lang=js"
import style0 from "./AudienceGrowthSettings.vue?vue&type=style&index=0&id=48c7ad50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7ad50",
  null
  
)

export default component.exports